import { z } from "zod";

export const contactSchema = z.object({
    firstName: z.string().min(1, "First name is required").max(100),
    lastName:  z.string().min(1, "Last name is required").max(100),
    userEmail: z.string().min(1, "Email is required").email("Enter a valid email address"),
    userPhone: z
        .string()
        .min(1, "Phone number is required")
        .regex(/^[+0-9\s()-]{7,20}$/, "Enter a valid phone number"),
    additionalInfo: z
        .string()
        .min(1, "Please tell us a bit about your inquiry")
        .max(2000, "Keep it under 2000 characters"),
});

export type ContactFormValues = z.infer<typeof contactSchema>;